import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DiagnosticadorVisorComponent } from './components/diagnosticador-visor/diagnosticador-visor.component';

const routes: Routes = [
  { path: 'diagnosticador-visor', component: DiagnosticadorVisorComponent },
  { path: '', redirectTo: 'diagnosticador-visor', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DiagnosticadorVisorRoutingModule {}
